<template>
  <div class="admin-sidebar">
    <div class="logo">管理员后台</div>

    <el-menu
        :default-active="$route.path"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
        class="menu"
    >
      <el-menu-item index="/admin/home">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </el-menu-item>

      <el-menu-item index="/admin/student">
        <i class="el-icon-user"></i>
        <span slot="title">学员管理</span>
      </el-menu-item>

      <el-menu-item index="/admin/learning-analysis">
        <i class="el-icon-data-analysis"></i>
        <span slot="title">学情分析</span>
      </el-menu-item>

      <el-menu-item index="/admin/teaching-suggestion">
        <i class="el-icon-data-analysis"></i>
        <span slot="title">教学建议</span>
      </el-menu-item>

      <el-menu-item index="/admin/question">
        <i class="el-icon-reading"></i>
        <span slot="title">题库管理</span>
      </el-menu-item>

      <el-menu-item index="/admin/online-monitor">
        <i class="el-icon-monitor"></i>
        <span slot="title">在线监控</span>
      </el-menu-item>

      <el-button
          type="primary"
          icon="el-icon-refresh"
          size="mini"
          style="margin: 10px; width: calc(100% - 20px);"
          @click="toggleLandscape">
        切换横屏展示
      </el-button>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'AdminSidebar',
  data() {
    return {
      isLandscape: false // 记录当前是否为横屏状态
    }
  },
  methods: {
    // 切换横竖屏
    toggleLandscape() {
      this.isLandscape = !this.isLandscape;
      if (this.isLandscape) {
        document.documentElement.classList.add('landscape-mode');
        this.$message.success('已切换至横向展示');
      } else {
        document.documentElement.classList.remove('landscape-mode');
        this.$message.info('已恢复竖向展示');
      }
    }
  }
}
</script>

<style scoped>
.admin-sidebar {
  width: 100%;
  height: 100%;
  background: #304156;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  letter-spacing: 1px;
}

.menu {
  border-right: none;
}

.menu /deep/ .el-menu-item {
  height: 52px;
  line-height: 52px;
  font-size: 15px;
  padding-left: 20px !important;
}

.menu /deep/ .el-menu-item i {
  margin-right: 8px;
  font-size: 16px;
}
</style>